import React, { useEffect, useState } from "react";

const PickupTimer = ({ createdAt, pickupTime }) => {
  const [timeLeft, setTimeLeft] = useState("");
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    const created = new Date(createdAt);
    const pickup = new Date(pickupTime);

    const timer = setInterval(() => {
      const now = new Date();
      const diff = pickup - now;

      if (diff <= 0) {
        setExpired(true);
        setTimeLeft("");
        clearInterval(timer);
      } else {
        // convert milliseconds → minutes and seconds
        const minutes = Math.floor((diff / 1000 / 60) % 60);
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const seconds = Math.floor((diff / 1000) % 60);

        // format as HH:MM:SS
        const formatted =
         
          `${minutes.toString().padStart(2, "0")}:` +
          `${seconds.toString().padStart(2, "0")}`;

        setTimeLeft(formatted);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [createdAt, pickupTime]);

  return (
    <div
      style={{
        fontWeight: "bold",
        color:"red",
        fontSize: "12px",marginLeft:"10px"
      }}
    >
      {expired ? "Expired" : ` Expire in ${timeLeft}`}
    </div>
  );
};

export default PickupTimer;
